import { render } from "./main-navigation.vue?vue&type=template&id=3ffcdf11&scoped=true"
import script from "./main-navigation.vue?vue&type=script&lang=js"
export * from "./main-navigation.vue?vue&type=script&lang=js"

import "./main-navigation.vue?vue&type=style&index=0&id=3ffcdf11&lang=scss&scoped=true"

import exportComponent from "/Users/home/Documents/GitHub/pixelswish vue 3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffcdf11"]])

export default __exports__